export const isPwaInstalled = () => {
    // For iOS (checks if the app is running in standalone mode)
    const isStandaloneIOS = window.navigator.standalone

    // For other platforms (checks display mode)
    const isStandaloneOther = window.matchMedia('(display-mode: standalone)')
        .matches

    // Return true if either condition is met
    return isStandaloneIOS || isStandaloneOther
}
